import localeMessageBox from '@/components/message-box/locale/zh-CN';
import localeLogin from '@/views/login/locale/zh-CN';

import localeWorkplace from '@/views/dashboard/workplace/locale/zh-CN';
import localeDashboardOverview from '@/views/dashboard/overview/locale/zh-CN';
import localeDashboardPayment from '@/views/dashboard/payment/locale/zh-CN';
/** simple */
import localeMonitor from '@/views/dashboard/monitor/locale/zh-CN';

import localeSearchTable from '@/views/list/search-table/locale/zh-CN';
import localeCardList from '@/views/list/card/locale/zh-CN';

import localeStepForm from '@/views/form/step/locale/zh-CN';
import localeGroupForm from '@/views/form/group/locale/zh-CN';

import localeBasicProfile from '@/views/profile/basic/locale/zh-CN';

import localeDataAnalysis from '@/views/visualization/data-analysis/locale/zh-CN';
import localeMultiDAnalysis from '@/views/visualization/multi-dimension-data-analysis/locale/zh-CN';

import localeSuccess from '@/views/result/success/locale/zh-CN';
import localeError from '@/views/result/error/locale/zh-CN';

import locale403 from '@/views/exception/403/locale/zh-CN';
import locale404 from '@/views/exception/404/locale/zh-CN';
import locale500 from '@/views/exception/500/locale/zh-CN';

import localeUserInfo from '@/views/user/info/locale/zh-CN';
import localeUserSetting from '@/views/user/setting/locale/zh-CN';
import localeUserManagement from '@/views/user/management/locale/zh-CN';

import localeStoreManagement from '@/views/store/management/locale/zh-CN';
import localeBackupStoreManagement from '@/views/store/backup/locale/zh-CN';
import localeArchiveStoreManagement from '@/views/store/archive/locale/zh-CN';
import localePaymentList from '@/views/payment/list/locale/zh-CN';
import localeStoreConfig from '@/views/payment/store-config/locale/zh-CN';
import localePaymentGateway from '@/views/payment/gateway/locale/zh-CN';
import localeOrderList from '@/views/order/list/locale/zh-CN';
import localeSubscriptionOrderList from '@/views/order/subscription-order-list/locale/zh-CN';
import localeSubscriptionList from '@/views/order/subscription/locale/zh-CN';
import localeEmailLog from '@/views/order/email-log/locale/zh-CN';
import localeExportRecords from '@/views/order/export-records/locale/zh-CN';
import localeEmailTemplate from '@/views/order/email-template/locale/zh-CN';
import localeMerchantManagement from '@/views/merchant/management/locale/zh-CN';
/** simple end */
import localeSettings from './zh-CN/settings';

export default {
  'menu.dashboard': '概览',
  'menu.dashboard.overview': '总览',
  'menu.dashboard.orders': '订单看板',
  'menu.dashboard.subscriptions': '订阅看板',
  'menu.dashboard.payment': '支付看板',
  'menu.server.dashboard': '概览-服务端',
  'menu.server.workplace': '工作台-服务端',
  'menu.server.monitor': '实时监控-服务端',
  'menu.list': '列表页',
  'menu.result': '结果页',
  'menu.exception': '异常页',
  'menu.form': '表单页',
  'menu.profile': '详情页',
  'menu.visualization': '数据可视化',
  'menu.user': '用户管理',
  'menu.user.management': '用户管理',
  'menu.store': '店铺管理',
  'menu.store.management': '店铺管理',
  'menu.store.backup': '备用店铺',
  'menu.store.archive': '店铺归档',
  'menu.payment': '支付管理',
  'menu.payment.list': '支付列表',
  'menu.payment.storeConfig': '店铺配置',
  'menu.payment.gateway': '支付网关',
  'menu.order': '订单管理',
  'menu.order.list': '订单列表',
  'menu.order.subscriptionOrderList': '订阅订单列表',
  'menu.order.emailTemplate': '邮件模板',
  'menu.subscription': '订阅管理',
  'menu.subscription.list': '订阅记录',
  'menu.subscription.emailLog': '邮件记录',
  'menu.exportRecords': '导出记录',
  // 兼容旧菜单文案 key（如有外部引用）
  'menu.order.subscription': '订阅记录',
  'menu.order.exportRecords': '导出记录',
  'menu.merchant': '商户管理',
  'menu.merchant.management': '商户管理',
  'menu.profileCenter': '个人中心',
  'menu.profileCenter.myInfo': '我的信息',
  'menu.arcoWebsite': 'Arco Design',
  'menu.faq': '常见问题',
  'footer.copyright': '欧翼 2026 © All rights reserved.',
  'navbar.docs': '文档中心',
  'navbar.action.locale': '切换为中文',
  'navbar.title': '欧翼店铺管理',
  ...localeSettings,
  ...localeMessageBox,
  ...localeLogin,
  ...localeWorkplace,
  ...localeDashboardOverview,
  ...localeDashboardPayment,
  /** simple */
  ...localeMonitor,
  ...localeSearchTable,
  ...localeCardList,
  ...localeStepForm,
  ...localeGroupForm,
  ...localeBasicProfile,
  ...localeDataAnalysis,
  ...localeMultiDAnalysis,
  ...localeSuccess,
  ...localeError,
  ...locale403,
  ...locale404,
  ...locale500,
  ...localeUserInfo,
  ...localeUserSetting,
  ...localeUserManagement,
  ...localeStoreManagement,
  ...localeBackupStoreManagement,
  ...localeArchiveStoreManagement,
  ...localePaymentList,
  ...localeStoreConfig,
  ...localePaymentGateway,
  ...localeOrderList,
  ...localeSubscriptionOrderList,
  ...localeSubscriptionList,
  ...localeEmailLog,
  ...localeExportRecords,
  ...localeEmailTemplate,
  ...localeMerchantManagement,
  /** simple end */
};
